import { useState } from 'react';
import { Button } from '../ui/button';
import { AMENITY_CATEGORIES, AMENITY_LABELS } from '../../lib/listingConstants';

const StepAmenities = ({ listing, patchDraft, onNext, saving }) => {
  const [selected, setSelected] = useState(new Set(listing.amenities || []));
  const toggle = (a) => {
    const next = new Set(selected);
    if (next.has(a)) next.delete(a); else next.add(a);
    setSelected(next);
  };
  const save = async () => {
    await patchDraft({ amenities: Array.from(selected) });
    onNext();
  };
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-extrabold text-slate-900">Amenities</h1>
        <p className="mt-1 text-sm text-slate-600">
          Tick everything that applies. Students use these filters when searching — be accurate.
        </p>
      </div>
      {Object.entries(AMENITY_CATEGORIES).map(([cat, items]) => (
        <div key={cat} className="space-y-2" data-testid={`amenity-cat-${cat}`}>
          <h2 className="text-sm font-heading font-bold text-slate-900">{cat}</h2>
          <div className="flex flex-wrap gap-1.5">
            {items.map((a) => (
              <button
                key={a}
                type="button"
                onClick={() => toggle(a)}
                className={`px-3 py-1.5 rounded-full border text-xs font-medium transition-colors ${
                  selected.has(a)
                    ? 'border-amber-500 bg-amber-50 text-amber-900'
                    : 'border-slate-200 bg-white text-slate-700 hover:border-amber-300'
                }`}
                data-testid={`amenity-${a}`}
              >
                {AMENITY_LABELS[a] || a}
              </button>
            ))}
          </div>
        </div>
      ))}
      <Button
        className="w-full btn-primary h-12 text-base"
        onClick={save}
        disabled={saving}
        data-testid="step-amenities-continue"
      >
        Continue ({selected.size} selected)
      </Button>
    </div>
  );
};

export default StepAmenities;
